<template>
  <section class="panel">
    <div class="toolbar">
      <el-input v-model="query.productName" placeholder="产品名称" clearable style="width:160px" />
      <el-input v-model="query.userNickname" placeholder="用户昵称" clearable style="width:140px" />
      <el-input v-model="query.userPhone" placeholder="用户手机号" clearable style="width:140px" />
      <el-select v-model="query.seriesCategoryId" placeholder="系列分类" clearable style="width:140px">
        <el-option v-for="item in categories.SERIES" :key="item.id" :label="item.name" :value="item.id" />
      </el-select>
      <el-select v-model="query.modelCategoryId" placeholder="型号分类" clearable style="width:140px">
        <el-option v-for="item in categories.MODEL" :key="item.id" :label="item.name" :value="item.id" />
      </el-select>
      <el-select v-model="query.performanceCategoryId" placeholder="性能分类" clearable style="width:140px">
        <el-option v-for="item in categories.PERFORMANCE" :key="item.id" :label="item.name" :value="item.id" />
      </el-select>
      <el-input v-model="query.batchNo" placeholder="批次号" clearable style="width:150px" />
      <el-select v-model="query.status" placeholder="防伪码状态" clearable style="width:130px">
        <el-option label="正常" value="VALID" />
        <el-option label="失效" value="REVOKED" />
      </el-select>
      <el-date-picker v-model="generatedRange" type="datetimerange" range-separator="至" start-placeholder="生成开始" end-placeholder="生成结束" value-format="yyyy-MM-dd HH:mm:ss" style="width:330px" />
      <el-date-picker v-model="query.manufactureDate" type="date" value-format="yyyy-MM-dd" placeholder="生产日期" style="width:150px" />
      <el-button class="btn-search" icon="el-icon-search" @click="search">查询</el-button>
      <el-button type="primary" icon="el-icon-plus" @click="openGenerate">批量生成</el-button>
      <el-button type="success" icon="el-icon-circle-check" :disabled="!selectedIds.length" @click="changeSelectedStatus('VALID')">批量设正常</el-button>
      <el-button type="warning" icon="el-icon-circle-close" :disabled="!selectedIds.length" @click="changeSelectedStatus('REVOKED')">批量设失效</el-button>
      <el-button class="btn-download" icon="el-icon-download" :disabled="!selectedIds.length" @click="downloadSelected">下载选中</el-button>
      <el-button class="btn-download" icon="el-icon-download" @click="downloadAll">全部下载</el-button>
      <el-button type="danger" :disabled="!selectedIds.length" @click="deleteSelected">批量删除</el-button>
    </div>
    <div class="muted" style="margin-bottom:10px">已跨页选择 {{ selectedIds.length }} 条</div>
    <el-table ref="table" :data="page.records" row-key="id" border size="small" @selection-change="selectionChange">
      <el-table-column type="selection" width="42" />
      <el-table-column prop="pid" label="PID" width="80" />
      <el-table-column prop="productName" label="产品名称" min-width="140" />
      <el-table-column prop="seriesCategoryName" label="系列分类" width="110" />
      <el-table-column prop="modelCategoryName" label="型号分类" width="110" />
      <el-table-column prop="performanceCategoryName" label="性能分类" width="110" />
      <el-table-column prop="batchNo" label="批次号" width="130" />
      <el-table-column prop="manufactureDate" label="生产日期" width="110" />
      <el-table-column prop="createTime" label="生成时间" width="170" />
      <el-table-column prop="code" label="防伪码" min-width="180" />
      <el-table-column prop="scanCount" label="扫码次数" width="90" />
      <el-table-column prop="userNickname" label="用户昵称" width="130" />
      <el-table-column prop="userPhone" label="用户手机号" width="130" />
      <el-table-column prop="status" label="状态" width="90">
        <template slot-scope="{ row }">
          <el-tag size="small" :type="statusTagType(row.status)">{{ statusLabel(row.status) }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="verifyStatus" label="核验状态" width="100">
        <template slot-scope="{ row }">
          <span>{{ verifyStatusLabel(row.verifyStatus) }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="qrUrl" label="码图" width="100">
        <template slot-scope="{ row }">
          <el-image v-if="row.qrUrl" :src="absolute(row.qrUrl)" :preview-src-list="[absolute(row.qrUrl)]" style="width:48px;height:48px" fit="cover" />
          <span v-else class="muted">未生成</span>
        </template>
      </el-table-column>
      <el-table-column label="核验二维码" width="170">
        <template slot-scope="{ row }">
          <el-tag size="small" :type="row.qrType === 'PLAIN_QR' ? 'success' : 'info'">
            {{ qrTypeLabel(row.qrType) }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="320">
        <template slot-scope="{ row }">
          <el-button size="mini" type="primary" @click="openScanRecords(row)">扫码记录</el-button>
          <el-button v-if="row.status !== 'VALID'" size="mini" type="success" @click="changeRowStatus(row, 'VALID')">设正常</el-button>
          <el-button v-if="row.status !== 'REVOKED'" size="mini" type="warning" @click="changeRowStatus(row, 'REVOKED')">设失效</el-button>
          <el-button size="mini" type="danger" icon="el-icon-delete" @click="remove(row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      class="pager"
      background
      layout="total, sizes, prev, pager, next"
      :current-page="page.page"
      :page-size="page.size"
      :page-sizes="[10, 20, 50, 100]"
      :total="page.total"
      @size-change="size => { query.size = size; search() }"
      @current-change="p => { query.page = p; load() }"
    />

    <el-dialog title="批量生成防伪码" :visible.sync="generateDialog" width="560px">
      <el-form label-position="top">
        <el-form-item label="产品">
          <el-select v-model="generateForm.productId" filterable style="width:100%">
            <el-option v-for="item in productOptions" :key="item.id" :label="productLabel(item)" :value="item.id" />
          </el-select>
        </el-form-item>
        <el-form-item label="批次号"><el-input v-model="generateForm.batchNo" /></el-form-item>
        <el-form-item label="数量"><el-input-number v-model="generateForm.quantity" :min="1" :max="10000" /></el-form-item>
        <el-form-item label="生产日期"><el-date-picker v-model="generateForm.manufactureDate" value-format="yyyy-MM-dd" /></el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="generateDialog = false">取消</el-button>
        <el-button type="primary" @click="generateCodes">生成</el-button>
      </span>
    </el-dialog>

    <el-dialog :title="scanDialogTitle" :visible.sync="scanDialog" width="960px">
      <div class="toolbar scan-record-toolbar">
        <el-input v-model="scanQuery.userNickname" placeholder="用户昵称" clearable style="width:150px" />
        <el-input v-model="scanQuery.userPhone" placeholder="用户手机号" clearable style="width:150px" />
        <el-select v-model="scanQuery.scanStatus" placeholder="扫码状态" clearable style="width:130px">
          <el-option label="正常" value="NORMAL" />
          <el-option label="本人复核" value="SELF_RECHECK" />
          <el-option label="异常" value="ABNORMAL" />
        </el-select>
        <el-date-picker
          v-model="scanRange"
          type="datetimerange"
          range-separator="至"
          start-placeholder="核验开始"
          end-placeholder="核验结束"
          value-format="yyyy-MM-dd HH:mm:ss"
          style="width:330px"
        />
        <el-button class="btn-search" icon="el-icon-search" @click="searchScanRecords">查询</el-button>
        <el-button @click="resetScanRecords">重置</el-button>
      </div>
      <el-table :data="scanPage.records" border size="small" v-loading="scanLoading">
        <div slot="empty">
          <span v-if="scanTarget && scanTarget.scanCount > 0">暂无扫码明细，当前仅有扫码次数统计</span>
          <span v-else>暂无扫码记录</span>
        </div>
        <el-table-column prop="userNickname" label="用户昵称" min-width="150" />
        <el-table-column prop="userPhone" label="用户手机号" width="140" />
        <el-table-column prop="userLocation" label="用户位置" min-width="190" />
        <el-table-column label="扫码状态" width="100">
          <template slot-scope="{ row }">
            <el-tag size="mini" :type="scanStatusType(row.scanStatus)">
              {{ scanStatusLabel(row.scanStatus) }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="scanTime" label="核验时间" width="170" />
      </el-table>
      <el-pagination
        class="pager"
        background
        layout="total, sizes, prev, pager, next"
        :current-page="scanPage.page"
        :page-size="scanPage.size"
        :page-sizes="[10, 20, 50, 100]"
        :total="scanPage.total"
        @size-change="size => { scanQuery.size = size; searchScanRecords() }"
        @current-change="p => { scanQuery.page = p; loadScanRecords() }"
      />
    </el-dialog>
  </section>
</template>

<script>
import http, { absoluteUrl, downloadFile } from '../api'

const blankPage = { total: 0, page: 1, size: 10, records: [] }
const categoryTypes = ['SERIES', 'MODEL', 'PERFORMANCE']
const statusText = { VALID: '正常', REVOKED: '失效' }
const verifyStatusText = { UNVERIFIED: '未核验', VERIFIED: '已核验' }

export default {
  data() {
    return {
      query: { page: 1, size: 10 },
      generatedRange: [],
      page: { ...blankPage },
      categories: { SERIES: [], MODEL: [], PERFORMANCE: [] },
      productOptions: [],
      selectedMap: {},
      syncingSelection: false,
      generateDialog: false,
      generateForm: {},
      scanDialog: false,
      scanLoading: false,
      scanTarget: null,
      scanQuery: { page: 1, size: 10 },
      scanRange: [],
      scanPage: { ...blankPage }
    }
  },
  computed: {
    selectedIds() {
      return Object.keys(this.selectedMap).map(id => Number(id))
    },
    scanDialogTitle() {
      return this.scanTarget ? `扫码记录 - ${this.scanTarget.code}` : '扫码记录'
    }
  },
  mounted() {
    this.loadCategories()
    this.loadProducts()
    this.load()
  },
  methods: {
    absolute: absoluteUrl,
    async loadCategories() {
      for (const type of categoryTypes) {
        this.categories[type] = await http.get('/admin/categories', { params: { categoryType: type } })
      }
    },
    async loadProducts() {
      const page = await http.get('/admin/products', { params: { page: 1, size: 1000, status: 'ON' } })
      this.productOptions = page.records
    },
    params() {
      const params = { ...this.query }
      if (this.generatedRange && this.generatedRange.length === 2) {
        params.generatedStart = this.generatedRange[0]
        params.generatedEnd = this.generatedRange[1]
      }
      return params
    },
    async load() {
      this.page = await http.get('/admin/codes', { params: this.params() })
      this.$nextTick(this.restoreSelection)
    },
    search() {
      this.query.page = 1
      this.load()
    },
    restoreSelection() {
      if (!this.$refs.table) return
      this.syncingSelection = true
      this.$refs.table.clearSelection()
      this.page.records.forEach(row => {
        if (this.selectedMap[row.id]) this.$refs.table.toggleRowSelection(row, true)
      })
      this.syncingSelection = false
    },
    selectionChange(selection) {
      if (this.syncingSelection) return
      const next = { ...this.selectedMap }
      this.page.records.forEach(row => delete next[row.id])
      selection.forEach(row => { next[row.id] = row })
      this.selectedMap = next
    },
    openGenerate() {
      const date = new Date().toISOString().slice(0, 10)
      this.generateForm = { batchNo: `BATCH${date.replaceAll('-', '')}${Date.now().toString().slice(-4)}`, quantity: 100, manufactureDate: date }
      this.generateDialog = true
    },
    async generateCodes() {
      const data = await http.post('/admin/codes/batch-generate', this.generateForm)
      const taskMessage = data.qrcodeTask && data.qrcodeTask.message
        ? data.qrcodeTask.message
        : '二维码生成任务已提交，后台处理中，请稍后刷新查看结果'
      this.$message({
        type: data.qrcodeTask && data.qrcodeTask.queued ? 'success' : 'warning',
        message: `已生成 ${data.generated} 个防伪码。${taskMessage}`,
        duration: 6000
      })
      this.generateDialog = false
      this.load()
    },
    scanParams() {
      const params = { ...this.scanQuery }
      if (this.scanRange && this.scanRange.length === 2) {
        params.scanStart = this.scanRange[0]
        params.scanEnd = this.scanRange[1]
      }
      return params
    },
    async openScanRecords(row) {
      this.scanTarget = row
      this.scanQuery = { page: 1, size: 10 }
      this.scanRange = []
      this.scanPage = { ...blankPage }
      this.scanDialog = true
      await this.loadScanRecords()
    },
    async loadScanRecords() {
      if (!this.scanTarget) return
      this.scanLoading = true
      try {
        this.scanPage = await http.get(`/admin/codes/${this.scanTarget.id}/scan-history`, { params: this.scanParams() })
      } finally {
        this.scanLoading = false
      }
    },
    searchScanRecords() {
      this.scanQuery.page = 1
      this.loadScanRecords()
    },
    resetScanRecords() {
      this.scanQuery = { page: 1, size: this.scanQuery.size || 10 }
      this.scanRange = []
      this.loadScanRecords()
    },
    productLabel(item) {
      return [item.name, item.seriesCategoryName, item.modelCategoryName, item.performanceCategoryName].filter(Boolean).join(' / ')
    },
    statusLabel(status) {
      return statusText[status] || status || '-'
    },
    statusTagType(status) {
      return status === 'VALID' ? 'success' : 'danger'
    },
    verifyStatusLabel(status) {
      return verifyStatusText[status] || status || '-'
    },
    qrTypeLabel(type) {
      return type === 'PLAIN_QR' ? '普通二维码（小程序内扫码）' : '小程序码（历史）'
    },
    scanStatusLabel(status) {
      const map = { NORMAL: '正常', SELF_RECHECK: '本人复核', ABNORMAL: '异常' }
      return map[status] || status || '-'
    },
    scanStatusType(status) {
      if (status === 'NORMAL') return 'success'
      if (status === 'SELF_RECHECK') return 'warning'
      return 'danger'
    },
    async updateStatus(ids, status) {
      await http.put('/admin/codes/status', { ids, status })
      this.$message.success(`已设为${this.statusLabel(status)}`)
      this.load()
    },
    async changeRowStatus(row, status) {
      await this.$confirm(`确认将防伪码 ${row.code} 设为${this.statusLabel(status)}？`)
      await this.updateStatus([row.id], status)
    },
    async changeSelectedStatus(status) {
      await this.$confirm(`确认将选中的 ${this.selectedIds.length} 个防伪码设为${this.statusLabel(status)}？`)
      await this.updateStatus(this.selectedIds, status)
    },
    async downloadSelected() {
      const params = new URLSearchParams()
      params.append('ids', this.selectedIds.join(','))
      await this.download(`/admin/codes/download?${params.toString()}`, 'qrcodes.zip')
    },
    async downloadAll() {
      const params = new URLSearchParams()
      Object.entries(this.params()).forEach(([key, value]) => {
        if (!['page', 'size'].includes(key) && value !== undefined && value !== null && value !== '') params.append(key, value)
      })
      await this.download(`/admin/codes/download?${params.toString()}`, 'qrcodes.zip')
    },
    async download(path, filename) {
      try {
        await downloadFile(path, filename)
      } catch (error) {
        this.$message.error(error.message || '下载失败')
      }
    },
    async remove(row) {
      await this.$confirm('确认删除该防伪码？')
      await http.delete(`/admin/codes/${row.id}`)
      const next = { ...this.selectedMap }
      delete next[row.id]
      this.selectedMap = next
      this.load()
    },
    async deleteSelected() {
      await this.$confirm(`确认删除选中的 ${this.selectedIds.length} 个防伪码？`)
      await http.delete('/admin/codes', { data: { ids: this.selectedIds } })
      this.selectedMap = {}
      this.load()
    }
  }
}
</script>
